let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("1XLq2")), load("497Y2")]).then(() => parcelRequire('hk4tW'));